import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const eventDescriptionStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            marginBottom: "60px",
            marginTop: "40px",
        },
        gridContainer: {
            marginTop: "25px",
            marginLeft: "50px",
        },
        text: { display: "inline", marginLeft: "12px" },
        linkText: { color: "#270ADC", cursor: "pointer" },
        title: {
            color: "#181818",
            fontWeight: 500,
            fontSize: "32px",
            marginBottom: "12px",
        },
        subTitle: {
            color: "#000000",
        },
    })
);
